import { RestoreData } from '@sb/feathers-types';
import { makeNamespacedLog } from '@sb/log';

import { getService } from '../utils';

const log = makeNamespacedLog('getRestoreData');

/**
 * The box's current restore state. Returns null when the response cannot be
 * parsed — during a software update feathers-bot can be a build ahead of
 * this bundle, and a restore banner is not worth crashing a page over.
 */
export async function getRestoreData(): Promise<RestoreData | null> {
  const response = await getService('restore')().find({ query: {} });

  const parsed = RestoreData.safeParse(response);

  if (!parsed.success) {
    log.warn('parse.fail', 'Unrecognized restore service response');

    return null;
  }

  return parsed.data;
}
